import { AUTH } from 'config/api-routes';
import { AUTH as AUTH_FE } from 'config/fe-routes';
import urlJoin from 'url-join';
import { GTM, GTMEvents, PIXEL } from 'utils/analytics';
import { GET, POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

import { getCountry, getLanguage } from '../utils/i18n';

export default class AuthService {
  async refreshToken() {
    const response = await POST(AUTH.TOKEN.REFRESH.POST(), undefined, {
      withCredentials: true,
      silentFail: true,
    });

    return formatResponse(response);
  }

  async getGuestToken(opts = {}) {
    const response = await POST(AUTH.TOKEN.GUEST.POST(), undefined, {
      withCredentials: true,
      ...opts,
    });

    return formatResponse(response);
  }

  async loginWithFacebook(opts: { publishProductOnLogin?: boolean } = {}) {
    const response = await GET(
      AUTH.LOGIN.FACEBOOK.GET({
        redirect: urlJoin(window.location.origin, AUTH_FE().as),
        language: getLanguage(),
        country: getCountry(),
        publishProductOnLogin: opts.publishProductOnLogin || undefined,
      }),
    );
    const { url: facebookAuthUrl } = response?.data?.data || {};

    if (!facebookAuthUrl) {
      throw new Error('Failed to login with Facebook');
    }

    window.location = facebookAuthUrl;
  }

  async loginWithGoogle(opts: { publishProductOnLogin?: boolean } = {}) {
    const response = await GET(
      AUTH.LOGIN.GOOGLE.GET({
        redirect: urlJoin(window.location.origin, AUTH_FE().as),
        language: getLanguage(),
        country: getCountry(),
        publishProductOnLogin: opts.publishProductOnLogin || undefined,
      }),
    );
    const { url: googleAuthUrl } = response?.data?.data || {};

    if (!googleAuthUrl) {
      throw new Error('Failed to login with Google');
    }

    window.location = googleAuthUrl;
  }

  async loginCallback(nonce: string, isNewAccount: boolean) {
    const response = await POST(
      AUTH.TOKEN.USER.POST(),
      {
        nonce,
      },
      {
        withCredentials: true,
        silentFail: true,
      },
    );

    if (isNewAccount) {
      PIXEL.track('CompleteRegistration', {});
      GTM.logEvent(GTMEvents.USER_SIGNUP);
    } else {
      GTM.logEvent(GTMEvents.USER_LOGIN);
    }

    return formatResponse(response);
  }
}
